/**
 * «El audio de esta compu no responde» — señal de proceso, una vez por carga.
 *
 * Caso real (encargo 51, 06/10/2026): con el servidor de audio del sistema
 * trabado (pipewire-pulse sin contestar tras fallar un auricular Bluetooth),
 * `getUserMedia` no resuelve nunca y CREAR un `AudioContext` bloquea el hilo
 * principal de Chrome ~40 s. La pantalla quedaba «Coach está pensando…» para
 * siempre. Cuando el pre-flight del mic se queda sin respuesta con el permiso
 * dado (`boundedMicPreflight`), se marca esto y la app deja de tocar el audio:
 * la charla sigue por escrito (sin reproductor ni SFX) y la pantalla lo dice.
 */
import { useEffect, useState } from 'react';

const EVENT = 'orborix:audio-stuck';
let stuck = false;

export function isAudioStuck(): boolean {
  return stuck;
}

export function markAudioStuck(): void {
  if (stuck) return;
  stuck = true;
  console.warn(
    '[voice] el audio del sistema no responde: la charla sigue por escrito y sin sonido',
  );
  if (typeof window !== 'undefined') window.dispatchEvent(new Event(EVENT));
}

export function useAudioStuck(): boolean {
  const [value, setValue] = useState(stuck);
  useEffect(() => {
    const on = (): void => setValue(true);
    window.addEventListener(EVENT, on);
    if (stuck) setValue(true);
    return () => window.removeEventListener(EVENT, on);
  }, []);
  return value;
}
